module.exports = __webpack_public_path__ + "img/regular_lease_overview_icon02.321d2637.svg";